<div class="header-box" [ngClass]="id ? 'with-info-box' : ''">
  <div class="d-flex align-items-center heading-box">
    <ng-icon [name]="mode == 'view' ? 'heroUsers' : (mode == 'edit' ? 'heroPencilSquare' : 'heroGlobeAlt')"></ng-icon>
    <div>
      <h2 *ngIf="mode"><small>{{ mode + ' Organisation' | titlecase }}</small></h2>
      <h2 *ngIf="formLoading; else loaded"><ngx-skeleton-loader
          [theme]="{ height: '20px', width: '200px'}"></ngx-skeleton-loader></h2>
      <ng-template #loaded>
        <h2>{{ id ? (orgData.organizationName | titlecase) : 'Add Organisation' }}
        </h2>
      </ng-template>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-center col-md-6 p-0">
    <button color="accent" mat-raised-button
      *ngIf="userService.permissionsValue['_USER_MANAGEMENT_EDIT_'] && mode == 'view'"
      [routerLink]="['/app/organisation','edit',id]">
      Edit Organisation</button>
  </div>
</div>
<div class="info-box" *ngIf="id">
  <div class="info-section">
    <h3><small>Organisation/Tenant Id</small></h3>
    <h3 *ngIf="formLoading; else loadedEid"><ngx-skeleton-loader
        [theme]="{ height: '15px', width: '150px'}"></ngx-skeleton-loader></h3>
    <ng-template #loadedEid>
      <h3>{{orgData.id}}</h3>
    </ng-template>
  </div>
  <div class="info-section">
    <h3><small>Status</small></h3>
    <h3 *ngIf="formLoading; else loadedStatus"><ngx-skeleton-loader
        [theme]="{ height: '15px', width: '150px'}"></ngx-skeleton-loader></h3>
    <ng-template #loadedStatus>
      <h3>{{orgData.status == 0 ? 'Inactive' : 'Active'}}</h3>
    </ng-template>
  </div>
  <div class="info-section" *ngIf="mode">
    <h3><small>Created By</small></h3>
    <h3 *ngIf="formLoading; else loadedName"><ngx-skeleton-loader
        [theme]="{ height: '15px', width: '150px'}"></ngx-skeleton-loader></h3>
    <ng-template #loadedName>
      <h3>{{orgData.createdBy| titlecase}}</h3>
    </ng-template>
  </div>
</div>
<div class="inner-box">
  <mat-card class="hide-stepper">
    <mat-card-content class="form-head">
      <div *ngIf="formLoading; else show">
        <ngx-skeleton-loader [theme]="{ height: '80px', width: '70%', margin: '0 auto'}"></ngx-skeleton-loader>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-4 mr-4">
          <ngx-skeleton-loader [theme]="{ height: '50px', width: '10%', float: 'right'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader
            [theme]="{ height: '50px', width: '30px', opacity: '0', float: 'right', visibility: 'hidden'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ height: '50px', width: '10%', float: 'right'}"></ngx-skeleton-loader>
        </div>
      </div>
      <ng-template #show>
        <mat-stepper linear="true" #stepper [disableRipple]="true">
          <mat-step [stepControl]="userForm">
            <form [formGroup]="userForm">
              <mat-accordion>
                <mat-expansion-panel expanded hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Organisation Details
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="col-md-12 align-items-center d-flex p-0">
                    <div class="col-md-2 profile-pic">
                      <div>
                        <a (click)="triggerFileInput()" [matTooltip]="'Change Profile Picture'"
                          [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
                          <mat-spinner *ngIf="isLoading" diameter="18" color="accent"></mat-spinner>
                          <ng-icon name="heroCamera" *ngIf="!isLoading"></ng-icon>
                        </a>
                        <input type="file" accept="image/*" #fileInput style="display: none"
                          (change)="onFileSelected($event)">
                        <img [src]="selectedImage ? selectedImage.toString() : ( base64Image ? base64Image : '/assets/img/img_avatar.png')" class="rounded-circle">
                      </div>
                    </div>
                    <div class="col-md-10 p-0 flex-wrap d-flex">
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Organisation Name</mat-label>
                            <input type="text" matInput autocomplete="off" formControlName="organizationName"
                              [errorStateMatcher]="matcher">
                            <mat-error *ngIf="userForm.get('organizationName').hasError('required')">
                              Organisation Name is required
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Registration Number</mat-label>
                            <input type="text" matInput autocomplete="off" formControlName="registrationNumber"
                              [errorStateMatcher]="matcher">
                            <mat-error *ngIf="userForm.get('registrationNumber').hasError('required')">
                              Registration Number is required
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Address Line 1</mat-label>
                            <input type="text" matInput autocomplete="off" formControlName="addressLine1"
                              [errorStateMatcher]="matcher">
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Address Line 2</mat-label>
                            <input type="text" matInput autocomplete="off" formControlName="addressLine2"
                              [errorStateMatcher]="matcher">
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Select Country</mat-label>
                            <mat-select formControlName="countryId" [errorStateMatcher]="matcher">
                              <mat-option *ngFor="let country of countries" [value]="country.id">{{ country.name
                                }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="userForm.get('countryId').hasError('required')">
                              Country is required
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Zip Code</mat-label>
                            <input type="number" matInput autocomplete="off" formControlName="zipCode"
                              [errorStateMatcher]="matcher">
                            <mat-error *ngIf="userForm.get('zipCode').hasError('required')">
                              Zip Code is required
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Number Of Employee</mat-label>
                            <input type="number" matInput autocomplete="off" formControlName="noOfEmployees"
                              [errorStateMatcher]="matcher">
                            <mat-error *ngIf="userForm.get('noOfEmployees').hasError('required')">
                              Number Of Employee is required
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Number Of Licences</mat-label>
                            <input type="number" matInput autocomplete="off" formControlName="noOfLicensesReq"
                              [errorStateMatcher]="matcher">
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Organisation Website</mat-label>
                            <input type="url" matInput autocomplete="off" formControlName="orgWebsite"
                              [errorStateMatcher]="matcher">
                            <mat-error *ngIf="userForm.get('orgWebsite').hasError('pattern')">
                              Invalid URL
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>

                  </div>
                </mat-expansion-panel>
              </mat-accordion>
              <div class="d-flex col-md-12 justify-content-end p-0">
                <button color="primary" class="outlined-btn" mat-raised-button *ngIf="mode != 'view'"
                  (click)="userForm.reset()" type="reset" [disabled]="isLoading">Reset</button>
                <button mat-raised-button color="accent" class="ml-3" matStepperNext>Next</button>
              </div>
            </form>
          </mat-step>
          <mat-step [stepControl]="contactForm">
            <form [formGroup]="contactForm">
              <mat-accordion>
                <mat-expansion-panel expanded hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Contact Information
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="flex-wrap d-flex p-0">
                    <div class="col-md-3">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Contact Name</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="firstName"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="contactForm.get('firstName').hasError('required')">
                            Name required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Contact Surname</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="lastName"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="contactForm.get('lastName').hasError('required')">
                            Surname is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Offical Email</mat-label>
                          <input type="email" matInput autocomplete="off" formControlName="officialEMail"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="contactForm.get('officialEMail').hasError('required')">
                            Email is required is required
                          </mat-error>
                          <mat-error *ngIf="contactForm.get('officialEMail').hasError('email')">
                            Invalid Email Address
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Contact Number</mat-label>
                          <input type="email" matInput autocomplete="off" formControlName="contactNumber"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="contactForm.get('contactNumber').hasError('required')">
                            Email is required is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
              <div class="d-flex col-md-12 justify-content-between p-0">

                <button mat-raised-button color="primary" class="outlined-btn" matStepperPrevious
                  [disabled]="isLoading">Back</button>
                <div>
                  <button color="primary" class="outlined-btn ml-3" mat-raised-button *ngIf="mode != 'view'"
                    (click)="contactForm.reset()" type="reset" [disabled]="isLoading">Reset</button>
                  <button color="accent" mat-raised-button (click)="addOrg(false)" *ngIf="mode != 'view'" class="ml-3"
                    [disabled]="isLoading">{{ mode ? 'Update' : 'Save' }}
                    <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                  </button>
                  <button color="accent" mat-raised-button (click)="addOrg(true)" *ngIf="!mode" class="ml-3"
                    [disabled]="isLoading">Save & Activate
                    <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                  </button>
                </div>
              </div>
            </form>
          </mat-step>
          <!-- <mat-step [stepControl]="planForm">
            <form [formGroup]="planForm">
              <mat-accordion>
                <mat-expansion-panel expanded hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Plan Details
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="flex-wrap d-flex p-0">
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Plan Name</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="name"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="planForm.get('name').hasError('required')">
                            Select Plan
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Plan Price</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="cost"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="planForm.get('cost').hasError('required')">
                            Select Price
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Start Date</mat-label>
                          <input matInput [matDatepicker]="picker" autocomplete="off" formControlName="startDate"
                            [errorStateMatcher]="matcher">
                          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                          <mat-error *ngIf="planForm.get('startDate').hasError('required')">
                            Select Start Date
                          </mat-error>
                          <mat-error
                            *ngIf="planForm.get('startDate').invalid && !planForm.get('startDate').hasError('required')">
                            Start Date is invalid
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>End Date</mat-label>
                          <input matInput [matDatepicker]="endDatePicker" autocomplete="off" formControlName="endDate"
                            [errorStateMatcher]="matcher">
                          <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                          <mat-datepicker #endDatePicker></mat-datepicker>
                          <mat-error *ngIf="planForm.get('endDate').hasError('required')">
                            Select End Date
                          </mat-error>
                          <mat-error
                            *ngIf="planForm.get('endDate').invalid && !planForm.get('endDate').hasError('required')">
                            End Date invalid
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Allowed Contract Type</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="maxContractTypes"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="planForm.get('maxContractTypes').hasError('required')">
                            Select Contract Type
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Contract Type Created</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="maxContracts"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="planForm.get('maxContracts').hasError('required')">
                            Select Contract Type
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">

                          <mat-label>Allowed Users</mat-label>

                          <input type="text" matInput autocomplete="off" formControlName="maxUsers"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="planForm.get('maxUsers').hasError('required')">
                            select user
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Active Users</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="activeUser"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="planForm.get('activeUser').hasError('required')">
                            Select active user
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Allow Transaction</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="allowTran"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="planForm.get('allowTran').hasError('required')">
                            Select allow transaction
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Total Transaction</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="totalTran"
                            [errorStateMatcher]="matcher">
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
              <div class="d-flex col-md-12 justify-content-between p-0">

                <button mat-raised-button color="primary" class="outlined-btn" matStepperPrevious
                  [disabled]="isLoading">Back</button>
                <div>
                  <button color="primary" class="outlined-btn ml-3" mat-raised-button *ngIf="mode != 'view'"
                    (click)="planForm.reset()" type="reset" [disabled]="isLoading">Reset</button>
                  <button color="accent" mat-raised-button (click)="addUser(false)" *ngIf="mode != 'view'" class="ml-3"
                    [disabled]="isLoading">{{ mode ? 'Update' : 'Save' }}
                    <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                  </button>
                  <button color="accent" mat-raised-button (click)="addUser(true)" *ngIf="!mode" class="ml-3"
                    [disabled]="isLoading">Save & Activate
                    <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                  </button>
                </div>
              </div>

            </form>
          </mat-step> -->
        </mat-stepper>
      </ng-template>
    </mat-card-content>
  </mat-card>
</div>